import React from 'react';
import { Box } from '@honda-canada/design-system-react';
import PropTypes from 'prop-types';

import themeStyles from './ProductLines.style';

const Container = themeStyles.apply(Box, 'Container');
const ProductLinesSection = themeStyles.apply(Box, 'ProductLinesSection');
const ProductLinesWrapper = themeStyles.apply(Box, 'ProductLinesWrapper');

const ProductLines = ({ title, children, leftAlign }) => (
  <Container data-testid="cy-dealer-productLines">
    {title}
    <ProductLinesSection leftAlign={leftAlign}>
      <ProductLinesWrapper>{children}</ProductLinesWrapper>
    </ProductLinesSection>
  </Container>
);

ProductLines.defaultProps = {
  leftAlign: false,
};

ProductLines.propTypes = {
  title: PropTypes.element,
  children: PropTypes.node,
  leftAlign: PropTypes.bool,
};

export default ProductLines;
